<template>
  <div :class="{'has-logo':showLogo}" class="sidebar-wrapper">
    <!-- Logo区域 -->
    <div class="logo-container" v-if="sidebar.opened">
      <div class="logo-icon" :style="{ backgroundImage: 'url(' + logoSrc + ')' }"></div>
      <div class="logo-text">
        <span class="logo-title">{{ enterpriseName }}</span>
        <span class="logo-subtitle">华油车辆智慧调度系统</span>
      </div>
    </div>

    <!-- 导航菜单 -->
    <scroll-bar class="menu-scrollbar">
      <el-menu
        mode="vertical"
        :unique-opened="true"
        :default-active="$route.path"
        :default-openeds="defaultOpeneds"
        class="sidebar-menu">
        <sidebar-item :routes="permission_routers"></sidebar-item>
      </el-menu>
    </scroll-bar>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import ScrollBar from '@/components/ScrollBar'
import {asyncRouterMap} from "../../../../router";
import logoImg from '@/assets/logo.png'

export default {
  components: { SidebarItem, Logo ,ScrollBar},
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    logoSrc() {
      return logoImg
    }
  },
  data() {
    return {
      enterpriseName: '华油惠通',
      defaultOpeneds: []
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (!this.permission_routers) return
        // 找到当前路由对应的父级菜单
        const findParentMenu = (routes, path) => {
          for (const route of routes) {
            if (route.children) {
              for (const child of route.children) {
                if (child.path === path || route.path + '/' + child.path === path) {
                  return route.name || route.path
                }
                // 递归检查更深层级的菜单
                if (child.children) {
                  const found = findParentMenu([child], path)
                  if (found) return route.name || route.path
                }
              }
            }
          }
          return null
        }

        const parentName = findParentMenu(this.permission_routers, route.path)
        if (parentName) {
          this.defaultOpeneds = [parentName]
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getEnterpriseInfo()
  },
  methods: {
    getEnterpriseInfo() {
      this.api({
        url: '/ceEnterprise/getByCurrent',
        method: 'post'
      }).then(data => {
        if (data.status === 0 && data.data) {
          this.enterpriseName = data.data.shortName || data.data.name || '金助云'
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
// 侧边栏包装器
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--sidebar-bg);
}

// Logo区域
.logo-container {
  display: flex;
  align-items: center;
  padding: 16px 16px 12px 16px;
  border-bottom: 1px solid var(--border-light);

  .logo-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin-right: 12px;
    flex-shrink: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .logo-text {
    display: flex;
    flex-direction: column;

    .logo-title {
      font-size: 16px;
      font-weight: 600;
      color: var(--text-primary);
      line-height: 1.3;
    }

    .logo-subtitle {
      font-size: 12px;
      color: var(--text-muted);
      line-height: 1.3;
    }
  }
}

// 菜单滚动条
.menu-scrollbar {
  flex: 1;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue